<app-loading-wrapper [loading]="loading">
    <div *ngIf="emails; else noEmails">
        <div class="margin-bottom-md">
            <button
                mat-raised-button
                color="primary"
                *ngIf="mayExport"
                (click)="export()">Export Emails</button>
        </div>
        <mat-card *ngFor="let email of emails">
            <app-email-view
                    [email]="email"
                    [domainClass]="domainClass"
                    [domainId]="id"
                    [mayResend]="mayResend"
                    [mayViewBcc]="maySeeBcc"
                    (emailResentEvent)="emailResent($event)"
            ></app-email-view>
        </mat-card>
    </div>
    <ng-template #noEmails>
        <mat-card>There are no emails to display.</mat-card>
    </ng-template>
</app-loading-wrapper>
